import React, { Component } from 'react';
import MembersList  from '../../components/members';
import EditMembers from '../../components/members/editMembers';
import {fetchAllMembers, editMember, updateProfile, showTransactionByuserID} from '../../actions/members';
import UserTransaction from '../../components/members/userTransaction';
import {connect} from 'react-redux';

class Members extends Component {
  constructor(props){
    super(props)
    this.state = {
    }

    this.showMembers = this.showMembers.bind(this);
    this.updateProfile = this.updateProfile.bind(this);
    this.editMember = this.editMember.bind(this);
    this.backMemberList = this.backMemberList.bind(this);
    this.showTransactionByuserID = this.showTransactionByuserID.bind(this);
  }

    componentWillMount() {
      let token=sessionStorage.getItem("adminToken");
     this.props.dispatch(fetchAllMembers(token));
    }

    backMemberList(){
      let token=sessionStorage.getItem("adminToken");
     this.props.dispatch(fetchAllMembers(token));
    }

    showMembers(){
      this.props.dispatch(fetchAllMembers());
    }

   
    editMember(data){
      this.props.dispatch(editMember(data));
    }

    updateProfile(data){
      this.props.dispatch(updateProfile(data));
    }

    showTransactionByuserID(userId){
      this.props.dispatch(showTransactionByuserID(userId));
    }

  render() {
    if(!this.props.authenticated){
         let adminToken=sessionStorage.getItem("adminToken");
          if(adminToken){
        //   this.props.dispatch(fetchStudy(userId, access_token));
         }else {
           alert("Please login.");
           this.props.history.push("login");
         }
  }

   let memberList ="";
   let editMembers = "";
   let showTransactionView = "";

       if(this.props.showMember){
          memberList = <MembersList
                        membersList = {this.props.membersList}
                        success = {this.props.success}
                        editMember = {this.editMember}
                        />
    }else if(this.props.showEditMembers){
          editMembers = <EditMembers
          userProfile = {this.props.editMemberData}
          updateProfile = {this.updateProfile}
          backMemberList = {this.backMemberList}
          showTransactionByuserID = {this.showTransactionByuserID}
                        />
    }else if(this.props.showUserTranaction){
          showTransactionView = <UserTransaction
          UserTranactionSuccess = {this.props.UserTranactionSuccess}
          UserTranactionData = {this.props.UserTranactionData}
          backMemberList = {this.backMemberList}
            />
    }
  
     

   return (<div>
          {memberList}
          {editMembers}
          {showTransactionView}
          </div>
   );
  }
}

const  mapStateToProps =(state) =>{
  return {
    authenticated : state.login.authenticated,
    membersList : state.members.membersList,
    success : state.members.success,
    showMember :  state.members.showMember,
    showEditMembers: state.members.showEditMembers,
    editMemberData: state.members.editMemberData,
    showUserTranaction : state.members.showUserTranaction,
    UserTranactionSuccess : state.members.UserTranactionSuccess,
    UserTranactionData : state.members.UserTranactionData,
  }
}

export default connect(mapStateToProps)(Members);



// WEBPACK FOOTER //
// ./src/pages/members/index.js